import { FC } from 'react'
import { useParams } from 'react-router-dom'

import { Param } from '@/models/params'
import { Spinner } from '@/components'

import { useSellTreezIndexMapping } from '../hooks'

const IndexMappingTabContent: FC<{ indexName: string }> = ({ indexName }) => {
  const { sellTreezId } = useParams<Param>()

  const { mappings, isLoading } = useSellTreezIndexMapping({
    sellTreezId: sellTreezId!,
    indexName,
  })

  return (
    <pre className="h-full rounded-lg border border-gray-100 p-6 text-gray-500 text-sm overflow-x-auto">
      {isLoading ? <Spinner /> : JSON.stringify(mappings, null, 2)}
    </pre>
  )
}

export { IndexMappingTabContent }
